import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PolitykaPrywatnosci() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-policy-page">
      <div className="bg-slate-900 py-8">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/">
            <Button variant="ghost" className="text-slate-400 hover:text-white mb-4">
              <ArrowLeft className="w-4 h-4 mr-2" />Strona główna
            </Button>
          </Link>
          <h1 className="font-heading font-bold text-2xl text-white">Polityka prywatności</h1>
          <p className="text-slate-400 mt-1">Serwis „Giełda Budowlana"</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-10 space-y-8 text-slate-700 leading-relaxed">

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§1. Informacje ogólne</h2>
            <p>Niniejsza Polityka prywatności określa zasady przetwarzania danych osobowych użytkowników serwisu internetowego „Giełda Budowlana" (dalej: „Serwis").</p>
            <p className="mt-2">Administratorem danych osobowych jest:</p>
            <p className="mt-1"><strong>Piotr Kowalczyk P&P Profinish</strong>, prowadzący działalność gospodarczą</p>
            <ul className="list-none mt-1 space-y-0.5 text-sm text-slate-600">
              <li>adres: ul. Banderii 4/276, 01-164 Warszawa</li>
              <li>e-mail: p.p.profinish@gmail.com</li>
            </ul>
            <p className="mt-2">(dalej: „Administrator").</p>
            <p className="mt-2">Administrator przetwarza dane osobowe zgodnie z obowiązującymi przepisami prawa, w szczególności:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 (RODO),</li>
              <li>ustawą o ochronie danych osobowych.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§2. Zakres przetwarzanych danych</h2>
            <p>Administrator może przetwarzać następujące dane osobowe użytkowników:</p>
            <div className="mt-3 space-y-3">
              <div>
                <p className="font-medium text-slate-900">Dane identyfikacyjne:</p>
                <ul className="list-disc pl-6 mt-1 space-y-0.5 text-sm"><li>imię i nazwisko,</li><li>nazwa firmy;</li></ul>
              </div>
              <div>
                <p className="font-medium text-slate-900">Dane kontaktowe:</p>
                <ul className="list-disc pl-6 mt-1 space-y-0.5 text-sm"><li>adres e-mail,</li><li>numer telefonu;</li></ul>
              </div>
              <div>
                <p className="font-medium text-slate-900">Dane związane z działalnością gospodarczą:</p>
                <ul className="list-disc pl-6 mt-1 space-y-0.5 text-sm"><li>NIP,</li><li>REGON,</li><li>dane do faktur;</li></ul>
              </div>
              <div>
                <p className="font-medium text-slate-900">Dane techniczne:</p>
                <ul className="list-disc pl-6 mt-1 space-y-0.5 text-sm"><li>adres IP,</li><li>dane zapisywane w logach serwera;</li></ul>
              </div>
              <div>
                <p className="font-medium text-slate-900">Dane związane z korzystaniem z Serwisu:</p>
                <ul className="list-disc pl-6 mt-1 space-y-0.5 text-sm"><li>treść ogłoszeń,</li><li>treść wiadomości i zapytań wysyłanych w systemie,</li><li>historia korzystania z funkcjonalności Serwisu;</li></ul>
              </div>
              <div>
                <p className="font-medium text-slate-900">Dane dotyczące zgód:</p>
                <ul className="list-disc pl-6 mt-1 space-y-0.5 text-sm"><li>akceptacja regulaminów,</li><li>zgody marketingowe (jeśli zostały wyrażone).</li></ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§3. Cele przetwarzania danych</h2>
            <p>Dane osobowe przetwarzane są w następujących celach:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>założenia i obsługi konta użytkownika,</li>
              <li>umożliwienia publikowania ogłoszeń oraz kontaktu pomiędzy użytkownikami,</li>
              <li>realizacji usług dostępnych w Serwisie, w tym usług płatnych,</li>
              <li>obsługi płatności i rozliczeń,</li>
              <li>obsługi reklamacji i zapytań,</li>
              <li>zapewnienia bezpieczeństwa Serwisu,</li>
              <li>realizacji obowiązków prawnych Administratora,</li>
              <li>przesyłania informacji marketingowych – wyłącznie w przypadku wyrażenia odrębnej zgody.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§4. Podstawa prawna przetwarzania danych</h2>
            <p>Dane osobowe przetwarzane są na podstawie:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>art. 6 ust. 1 lit. b RODO</strong> – wykonanie umowy (korzystanie z Serwisu),</li>
              <li><strong>art. 6 ust. 1 lit. c RODO</strong> – obowiązek prawny Administratora,</li>
              <li><strong>art. 6 ust. 1 lit. f RODO</strong> – prawnie uzasadniony interes Administratora (np. bezpieczeństwo, analiza działania Serwisu),</li>
              <li><strong>art. 6 ust. 1 lit. a RODO</strong> – zgoda użytkownika (marketing).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§5. Odbiorcy danych</h2>
            <p>Dane osobowe mogą być przekazywane podmiotom współpracującym z Administratorem, wyłącznie w zakresie niezbędnym do świadczenia usług, w szczególności:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>operatorom płatności (np. Stripe),</li>
              <li>dostawcom usług hostingowych i baz danych (np. Supabase),</li>
              <li>dostawcom usług mailingowych.</li>
            </ul>
            <p className="mt-2">Dane nie są przekazywane innym użytkownikom Serwisu, z wyjątkiem informacji udostępnianych dobrowolnie przez użytkownika w ramach ogłoszeń lub profilu.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§6. Przekazywanie danych poza UE</h2>
            <p>Dane osobowe mogą być przetwarzane przez podmioty mające siedzibę poza Europejskim Obszarem Gospodarczym.</p>
            <p className="mt-1">W takim przypadku Administrator zapewnia odpowiedni stopień ochrony danych, zgodnie z RODO (np. standardowe klauzule umowne).</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§7. Okres przechowywania danych</h2>
            <p>Dane osobowe przechowywane są przez okres:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>trwania konta użytkownika,</li>
              <li>obowiązywania umów i usług,</li>
              <li>wymagany przepisami prawa.</li>
            </ul>
            <p className="mt-2">Po usunięciu konta dane mogą być przechowywane w zakresie wymaganym przepisami prawa lub do czasu przedawnienia roszczeń.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§8. Prawa użytkownika</h2>
            <p>Użytkownik ma prawo do:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>dostępu do swoich danych,</li>
              <li>ich sprostowania,</li>
              <li>usunięcia danych,</li>
              <li>ograniczenia przetwarzania,</li>
              <li>przenoszenia danych,</li>
              <li>wniesienia sprzeciwu wobec przetwarzania,</li>
              <li>cofnięcia zgody w dowolnym momencie (bez wpływu na zgodność przetwarzania przed cofnięciem),</li>
              <li>wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§9. Zgody marketingowe</h2>
            <p>Użytkownik może dobrowolnie wyrazić zgodę na otrzymywanie informacji marketingowych drogą elektroniczną.</p>
            <p className="mt-1">Zgoda ta nie jest warunkiem korzystania z Serwisu.</p>
            <p className="mt-1">Użytkownik może w każdej chwili wycofać zgodę.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§10. Bezpieczeństwo danych</h2>
            <p>Administrator stosuje odpowiednie środki techniczne i organizacyjne w celu ochrony danych osobowych.</p>
            <p className="mt-1">Dostęp do danych mają wyłącznie osoby upoważnione.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§11. Zmiany Polityki prywatności</h2>
            <p>Administrator zastrzega sobie prawo do zmiany niniejszej Polityki prywatności.</p>
            <p className="mt-1">Aktualna wersja dokumentu jest zawsze dostępna w Serwisie.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§12. Postanowienia końcowe</h2>
            <p>W sprawach nieuregulowanych niniejszą Polityką prywatności zastosowanie mają przepisy prawa polskiego.</p>
            <p className="mt-1">Polityka prywatności obowiązuje od dnia publikacji w Serwisie.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
